package ru.it_mozaika.utils

import io.ktor.client.call.*
import io.ktor.client.statement.*
import io.ktor.http.*


suspend fun HttpResponse.checkResponseError(): String? {
    return when (status) {
        HttpStatusCode.OK, HttpStatusCode.NoContent, HttpStatusCode.Created -> null
        HttpStatusCode.NotFound -> "Элемент не найден"
        HttpStatusCode.BadRequest -> "Ошибка в запросе: ${body<String>()}"
        else -> "Неизвестная ошибка: $status ${body<String>()}"
    }
}